module.exports = __webpack_public_path__ + "static/pauloakenfold_2-19421e1a3d6ffb9ccc551744051aeba8.jpg";